<template>
  <div class="share-order-page">
    <div id="shareOrderMap" class="map-container"></div>
    <section v-if="hasOrder" class="status-card">
      <div class="status-card-header">
        <img src="@/assets/image/order-tab.png" alt="" class="order-tab">
        <div class="order-number">
          <img src="@/assets/image/bee-logo.png" alt="" class="bee-logo">
          <span>订单单号：{{ orderDetails.orderNumber || '--' }}</span>
          <button type="button" class="copy-button" @click="copyOrderNumber"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M4.625 1.25H9.875C10.1071 1.25 10.3296 1.34219 10.4937 1.50628C10.6578 1.67038 10.75 1.89294 10.75 2.125V7.375C10.75 7.60707 10.6578 7.82962 10.4937 7.99372C10.3296 8.15781 10.1071 8.25 9.875 8.25H4.625C4.39294 8.25 4.17038 8.15781 4.00628 7.99372C3.84219 7.82962 3.75 7.60707 3.75 7.375V2.125C3.75 1.89294 3.84219 1.67038 4.00628 1.50628C4.17038 1.34219 4.39294 1.25 4.625 1.25ZM4.625 2C4.59185 2 4.56005 2.01317 4.53661 2.03661C4.51317 2.06005 4.5 2.09185 4.5 2.125V7.375C4.5 7.39142 4.50323 7.40767 4.50952 7.42284C4.5158 7.438 4.52501 7.45178 4.53661 7.46339C4.54822 7.475 4.562 7.4842 4.57717 7.49049C4.59233 7.49677 4.60859 7.5 4.625 7.5H9.875C9.90815 7.5 9.93995 7.48683 9.96339 7.46339C9.98683 7.43995 10 7.40815 10 7.375V2.125C10 2.09185 9.98683 2.06005 9.96339 2.03661C9.93995 2.01317 9.90815 2 9.875 2H4.625ZM7.5 9C7.5 8.90054 7.53951 8.80516 7.60984 8.73484C7.68016 8.66451 7.77554 8.625 7.875 8.625C7.97446 8.625 8.06984 8.66451 8.14017 8.73484C8.21049 8.80516 8.25 8.90054 8.25 9V9.875C8.25 10.1071 8.15781 10.3296 7.99372 10.4937C7.82962 10.6578 7.60707 10.75 7.375 10.75H2.125C1.89294 10.75 1.67038 10.6578 1.50628 10.4937C1.34219 10.3296 1.25 10.1071 1.25 9.875V4.625C1.25 4.39294 1.34219 4.17038 1.50628 4.00628C1.67038 3.84219 1.89294 3.75 2.125 3.75H3C3.09946 3.75 3.19484 3.78951 3.26517 3.85984C3.33549 3.93016 3.375 4.02554 3.375 4.125C3.375 4.22446 3.33549 4.31984 3.26517 4.39017C3.19484 4.46049 3.09946 4.5 3 4.5H2.125C2.09185 4.5 2.06005 4.51317 2.03661 4.53661C2.01317 4.56005 2 4.59185 2 4.625V9.875C2 9.90815 2.01317 9.93995 2.03661 9.96339C2.06005 9.98683 2.09185 10 2.125 10H7.375C7.40815 10 7.43995 9.98683 7.46339 9.96339C7.48683 9.93995 7.5 9.90815 7.5 9.875V9Z" fill="#FBE2AF"/>
</svg></button>
        </div>
        <div class="status-card-header-right" @click="handleColdData">
          <span style="margin-right: 4px;vertical-align: 1px;">冷藏数据</span>
          <!-- <van-icon name="arrow" /> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M8.79141 6C8.79141 6.12422 8.74219 6.24375 8.6543 6.33164L3.8707 11.1141C3.68789 11.2969 3.39141 11.2969 3.20742 11.1141C3.02461 10.9313 3.02461 10.6348 3.20742 10.4508L7.65937 6L3.20742 1.54922C3.02461 1.36641 3.02461 1.06993 3.20742 0.885942C3.39023 0.703129 3.68672 0.703129 3.8707 0.885942L8.6543 5.66836C8.74219 5.75625 8.79141 5.87578 8.79141 6Z" fill="#3D3833"/>
        </svg>
        </div>
      </div>
      <div class="status-card-body">
        <div class="status-card-body-left">
          <div class="status-title">
            {{ currentStatus }}
            <!-- <span v-if="statusBadge" class="status-badge">{{ statusBadge }}</span> -->
          </div>
          <div class="pickup-time">
            <div v-if="pickupTimeTip" class="pickup-time-tip">{{ pickupTimeTip }}</div>
            {{ statusTimeDisplay.label }}：{{ formatShortTime(statusTimeDisplay.time) }}
          </div>
        </div>
        <div class="city-route">
          <span>{{ orderDetails.startCity || '--' }}</span>
          <span class="route-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none">
                <path d="M6.45459 6.64902L6.45459 17.3414C6.45459 17.3836 6.45965 17.4274 6.46807 17.4679C6.47144 17.4864 6.47987 17.505 6.48492 17.5235C6.49166 17.5454 6.49672 17.5673 6.50514 17.5893C6.51357 17.6112 6.52705 17.6297 6.53716 17.6499C6.54559 17.6668 6.55401 17.6837 6.56412 17.7005C6.61131 17.7713 6.67366 17.8337 6.74443 17.8809C6.76128 17.891 6.77813 17.8994 6.79499 17.9079C6.81521 17.9197 6.83543 17.9315 6.85565 17.9399C6.87756 17.9483 6.89946 17.9534 6.92137 17.9601C6.93991 17.9652 6.95676 17.9719 6.97698 17.977C7.06124 17.9938 7.14718 17.9938 7.23143 17.977C7.24997 17.9736 7.26851 17.9669 7.28704 17.9601C7.30895 17.9534 7.33086 17.9483 7.35276 17.9399C7.37467 17.9315 7.3932 17.918 7.41343 17.9079C7.43028 17.8994 7.44713 17.891 7.46398 17.8809C7.49937 17.8573 7.53307 17.8303 7.5634 17.8L12.8092 12.5522C13.0637 12.2977 13.0637 11.8863 12.8092 11.6335C12.5547 11.3806 12.1436 11.3789 11.8908 11.6335L7.75382 15.7737L7.75382 6.64902C7.75382 6.28996 7.4623 6.00001 7.10505 6.00001C6.74612 5.99832 6.45459 6.28996 6.45459 6.64902Z" fill="#3D3833"/>
            </svg>
          </span>
          <span>{{ orderDetails.endCity || '--' }}</span>
        </div>
      </div>
    </section>

    <floating-panel ref="floatingPanel" :anchors="floatingPanelAnchors" :default-current="0">
        <template #sliding-area>
            <section v-if="hasOrder && (orderDetails.driver || orderDetails.car)" class="driver-card">
            <van-image
                width="40"
                height="40"
                round
                fit="cover"
                :src="driverAvatar"
            />
            <div class="driver-copy">
                <div class="driver-name">{{ driverName }}</div>
                <div class="car-description">
                {{ carPlateNumber }}&nbsp;&nbsp;{{ carDescription }}
                </div>
            </div>
            <!-- <span v-if="orderDetails.driver && orderDetails.driver.sex" class="sex-tag">
                {{ orderDetails.driver.sex }}
            </span> -->
            </section>
        </template>

        <main v-if="hasOrder" class="details-panel">
        <div class="tabs">
            <div
            :class="{ 'tab-item': true, active: activeTab === 'detail' }"
            @click="activeTab = 'detail'"
            >
            订单详情
            </div>
            <div
            :class="{ 'tab-item': true, active: activeTab === 'node' }"
            @click="activeTab = 'node'"
            >
            物流节点
            </div>
        </div>

        <div v-show="activeTab === 'detail'" class="detail-content">
            <div class="summary-row">
            <span class="summary-icon">提</span>
            <span>预计提货时间：</span>
            <span class="summary-value">{{ display(orderDetails.deliveryTime) }}</span>
            </div>

            <section class="address-section">
            <h3>装货地址</h3>
            <div v-if="!loadingAddressList.length" class="address-card empty-address">--</div>
            <div
                v-for="(item, index) in loadingAddressList"
                :key="item.sortId == null ? `loading-${index}` : `loading-${item.sortId}`"
                class="address-card"
            >
                <div class="address-label">[装货地址{{ loadingAddressList.length > 1 ? index + 1 : '' }}]</div>
                <div class="factory-name">{{ display(item.factoryName?item.factoryName:item.title) }}</div>
                <div class="detailed-address">{{ fullAddress(item) }}</div>
                <div class="address-contact">
                <span class="contact-label">联系人：</span>
                <span class="contact-value">{{ addressContact(item) }}</span>
                </div>
            </div>
            </section>
            <section class="address-section">
            <h3>卸货地址</h3>
            <div v-if="!unloadingAddressList.length" class="address-card empty-address">--</div>
            <div
                v-for="(item, index) in unloadingAddressList"
                :key="item.sortId == null ? `unloading-${index}` : `unloading-${item.sortId}`"
                class="address-card"
            >
                <div class="address-label unloading">[卸货地址{{ unloadingAddressList.length > 1 ? index + 1 : '' }}]</div>
                <div class="factory-name">{{ display(item.factoryName?item.factoryName:item.title) }}</div>
                <div class="detailed-address">{{ fullAddress(item) }}</div>
                <div class="address-contact">
                <span class="contact-label">联系人：</span>
                <span class="contact-value">{{ addressContact(item) }}</span>
                </div>
            </div>
            </section>

            <div class="info-list">
            <div class="info-row">
                <span>订单线路：</span>
                <span>{{ display(orderDetails.transportLine) }}</span>
            </div>
            <div class="info-row">
                <span>归属日期：</span>
                <span>{{ display(orderDetails.belongToDate) }}</span>
            </div>
            <div class="info-row">
                <span>货物名称：</span>
                <span>{{ display(orderDetails.loadingCargoType) }}</span>
            </div>
            <div class="info-row">
                <span>货物信息：</span>
                <span>{{ cargoInformation }}</span>
            </div>
            <div class="info-row">
                <span>下单信息：</span>
                <span>{{ orderCreateInformation }}</span>
            </div>
            <div class="info-row">
                <span>客户备注：</span>
                <span>{{ display(orderDetails.remark) }}</span>
            </div>
            </div>
        </div>

        <node-list v-show="activeTab === 'node'" :list="trackList" />
        </main>

        <div v-else-if="loaded" class="empty-state">暂无订单详情</div>
    </floating-panel>
  </div>
</template>

<script>
import { Image as VanImage, Toast ,Icon} from 'vant';
import floatingPanel from "@/views/mobileShareOrderDetails/components/floating-panel.vue";

import { getShareOrderDetail } from '@/api/shareOrderDetails';
import {
  directionDriving,
  geocoder
} from '@/api/beecargo/addressBook/logisticsDetails';
import { copyText, formatMinutes } from '@/utils';
import Donut from '@/utils/mapFun';
import NodeList from './components/node-list.vue';


export default {
  name: 'ShareOrderDetails',
  components: {
    [VanImage.name]: VanImage,
    [Icon.name]: Icon,
    NodeList,
    floatingPanel
  },
  data() {
    return {
      activeTab: 'detail',
      orderDetails: {},
      loaded: false,
      map: null,
      markerLayer: null,
      polylineLayer: null,
      distanceOverlay: null,
      loadedAddressOverlays: [],
      signedAddressOverlays: [],
      refreshTimer: null,
      pickupTimer: null,
      currentTimestamp: Date.now(),
      // 订单和司机信息弹窗锚点
      floatingPanelAnchors:[
        Math.round(0.6 * window.innerHeight),
        Math.round(0.4 * window.innerHeight),
        128,
      ],
    };
  },
  computed: {
    hasOrder() {
      return Boolean(this.orderDetails && this.orderDetails.orderNumber);
    },
    loadingAddressList() {
      return this.sortAddresses(this.orderDetails.loadingAddressList);
    },
    unloadingAddressList() {
      return this.sortAddresses(this.orderDetails.unloadingAddressList);
    },
    trackList() {
      return Array.isArray(this.orderDetails.trackList) ? this.orderDetails.trackList : [];
    },
    currentStatus() {
      if (this.orderDetails.trackList && this.orderDetails.trackList.length > 0) return this.orderDetails.trackList[0].nodeName;
      const state = Number(this.orderDetails.state);
      if (state >= 6) return '已签收';
      if (state === 5) return '运输中';
      if (state > 0) return '等待运输';
      return '--';
    },
    statusBadge() {
      if (Number(this.orderDetails.state) >= 6) return '准时送达';
      return '';
    },
    driverAvatar() {
      return (this.orderDetails.driver && this.orderDetails.driver.headSculpture)
        || require('@/assets/image/map-driver-icon.png');
    },
    driverName() {
      return this.display(this.orderDetails.driver && this.orderDetails.driver.driverName);
    },
    carPlateNumber() {
      return this.display(this.orderDetails.car && this.orderDetails.car.carPlateNumber);
    },
    carDescription() {
      const car = this.orderDetails.car || {};
      return [car.carTypeCategory, car.carTypeDetail].join(' ') || '--';
    },
    cargoInformation() {
      const details = [];
      if (this.orderDetails.loadingCargoNumber) {
        details.push(`${this.orderDetails.loadingCargoNumber}${this.orderDetails.loadingCargoType || ''}`);
      }
      if (this.orderDetails.totalVolume) details.push(`${this.orderDetails.totalVolume}m³`);
      if (this.orderDetails.totalWeight) details.push(`${this.orderDetails.totalWeight}T`);
      return details.join(' ') || '--';
    },
    orderCreateInformation() {
      return [this.orderDetails.orderCreateBy, this.orderDetails.createTime].filter(Boolean).join('  ') || '--';
    },
    statusTimeDisplay() {
      const code = this.orderDetails.orderLinkCode;
      const getNodeTime = (nodeCode) => {
        const node = this.trackList.find(item => item.nodeCode === nodeCode);
        return node ? node.nodeTime : '';
      };
      const rules = [
        { codes: ['接单', 'start', '前往装货地'], label: '预计提货时间', time: this.orderDetails.deliveryTime },
        { codes: ['arriveDelivery', 'beginningLoading', 'completionLoading'], label: '到达提货时间', time: getNodeTime('arriveDelivery') },
        { codes: ['leavePhoto'], label: '预计送达时间', time: this.orderDetails.estimatedArrivalTime },
        { codes: ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'], label: '到达卸货时间', time: getNodeTime('arriveUploads') },
        { codes: ['receipt'], label: '签收时间', time: getNodeTime('receipt') }
      ];
      const matched = rules.find(rule => rule.codes.includes(code));
      if (matched) {
        return { label: matched.label, time: matched.time };
      }
      return { label: '预计提货时间', time: this.orderDetails.deliveryTime };
    },
    pickupTimeTip() {
      const pickupCodes = ['接单', 'start', '前往装货地'];
      const currentCode = (this.trackList[0] && this.trackList[0].nodeCode)
        || this.orderDetails.orderLinkCode;
      if (!pickupCodes.includes(currentCode) || !this.orderDetails.deliveryTime) return '';
      return this.formatPickupCountdown(this.orderDetails.deliveryTime, this.currentTimestamp);
    },
  },
  async created() {
    await this.loadOrderDetail();
    this.pickupTimer = setInterval(() => {
      this.currentTimestamp = Date.now();
      // 地图气泡是原生 DOM 覆盖物，需要主动重建以刷新提货倒计时。
      if (this.trackList[0] && this.trackList[0].nodeCode === '接单') {
        const driver = this.driverPoint();
        if (driver && this.map) this.showAcceptedOrder(driver.position);
      }
    }, 60000);
    if (Number(this.orderDetails.state) === 5) {
      this.refreshTimer = setInterval(() => this.loadOrderDetail(true), 35000);
    }
  },
  beforeDestroy() {
    if (this.refreshTimer) clearInterval(this.refreshTimer);
    if (this.pickupTimer) clearInterval(this.pickupTimer);
    this.destroyMapLayers();
  },
  methods: {
    display(value) {
      return value === 0 || value ? value : '--';
    },
    fullAddress(item) {
      if (!item) return '--';
      const parts = [item.province, item.city, item.district];
      const prefix = parts.filter(Boolean).join('');
      const detail = item.detailedAddress || '';
      return `${prefix}${detail.startsWith(prefix) ? detail.slice(prefix.length) : detail}` || '--';
    },
    addressContact(item) {
      if (!item) return '--';
      const name = item.realName || item.factoryLinkName || item.linkName || item.name;
      const phone = item.phoneNumber || item.factoryLinkPhone || item.linkPhone || item.phone;
      return [name, phone].filter(Boolean).join('  ') || '--';
    },
    sortAddresses(list) {
      if (!Array.isArray(list)) return [];
      return list.slice().sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0));
    },
    formatShortTime(value) {
      if (!value) return '--';
      const parts = String(value).split(' ');
      return parts.length > 1 ? `${parts[0].slice(5).replace('-', '月')}日 ${parts[1].slice(0, 5)}` : value;
    },
    goBack() {
      if (window.history.length > 1) this.$router.back();
    },
    copyOrderNumber() {
      if (this.orderDetails.orderNumber) copyText(this.orderDetails.orderNumber);
    },
    async loadOrderDetail(silent = false) {
      const shareCode = this.$route.query.shareCode;
      if (!shareCode) {
        this.loaded = true;
        Toast.fail('缺少分享码');
        return;
      }
      try {
        const { data } = await getShareOrderDetail({ shareCode });
        this.orderDetails = data || {};
        this.loaded = true;
        await this.$nextTick();
        await this.renderMap(!silent);
        if(data.state === 6){
          this.refreshTimer && clearInterval(this.refreshTimer);
        }
      } catch (error) {
        this.loaded = true;
        if (!silent) console.error('获取分享订单详情失败', error);
      }
    },
    async renderMap(shouldFitMap = true) {
      if (!this.hasOrder) return;
      if (!window.TMap) await this.createMap();
      if (!this.map) {
        this.map = new TMap.Map('shareOrderMap', {
          rotation: 0,
          pitch: 0,
          zoom: 10,
          mapStyleId: 'style1'
        });
        // 去除地图控件中的缩放和旋转按钮
        this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
        this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
      }
      this.destroyMapLayers();
      const loadingPoints = await this.resolveAddressPoints(this.loadingAddressList, 'loading');
      const unloadingPoints = await this.resolveAddressPoints(this.unloadingAddressList, 'unloading');
      const currentNode = this.trackList[0] || {};
      const code = currentNode.nodeCode || currentNode.node;
      const currentCode = this.orderDetails.orderLinkCode || code;
      const isAccepted = code === '接单';
      const isHeadingToLoading = currentNode.nodeCode === '前往装货地'
        || currentNode.node === '前往装货地';
      const allLoadingCompleted = this.isAllLoadingCompleted();
      const isHeadingToFirstUnloading = allLoadingCompleted
        || (this.orderDetails.orderLinkCode !== 'start'
        && currentNode.nodeCode === 'leavePhoto'
        && this.orderDetails.receivingLocationItems === null);
      const receivingItems = Array.isArray(this.orderDetails.receivingLocationItems)
        ? this.orderDetails.receivingLocationItems
        : [];
      const isHeadingToNextUnloading = currentNode.nodeCode === 'completeDischarge'
        && this.orderDetails.orderLinkCode === 'leavePhoto'
        && receivingItems.length > 0
        && receivingItems.length < this.unloadingAddressList.length;
      // 装卸货操作阶段通常隐藏司机位置；完成某站卸货并离场时需同时展示司机 Marker。
      const operationStatusCodes = [
        'arriveDelivery', 'beginningLoading', 'completionLoading',
        'arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'
      ];
      const shouldShowDriver = isAccepted || isHeadingToLoading || isHeadingToFirstUnloading
        || isHeadingToNextUnloading
        || (!operationStatusCodes.includes(currentCode)
        && (currentCode === 'start'
          || currentCode === '前往装货地'
          || currentCode === 'leavePhoto'));
      // 完成卸货并前往下一地址时同时展示司机位置与最近一次卸货记录。
      const position = shouldShowDriver
        && (currentNode.nodeCode !== 'completeDischarge' || isHeadingToNextUnloading)
        ? this.driverPoint()
        : null;
      // 装卸货阶段使用对应地址展示当前状态 Marker。
      const operationStatusPoint = this.getOperationStatusPoint();
      const loadedAddressStatusPoints = this.getLoadedAddressStatusPoints(
        loadingPoints,
        operationStatusPoint
      );
      const signedAddressStatusPoints = this.getSignedAddressStatusPoints(
        unloadingPoints,
        operationStatusPoint
      );
      const track = code === 'receipt' ? [] : this.trackPoints();
      const markers = loadingPoints.concat(unloadingPoints);
      if (position) markers.push(position);
      if (operationStatusPoint) markers.push(operationStatusPoint);
      this.drawMarkers(markers);
      if (isAccepted && position) this.showAcceptedOrder(position.position);
      if (operationStatusPoint) this.showOperationStatus(operationStatusPoint);
      if (loadedAddressStatusPoints.length) {
        this.showLoadedAddressStatuses(loadedAddressStatusPoints);
      }
      if (signedAddressStatusPoints.length) {
        this.showSignedAddressStatuses(signedAddressStatusPoints);
      }
      await this.drawRoutes(loadingPoints, unloadingPoints, position, track);
      if (shouldFitMap) this.fitMap(markers.concat(track));
    },
    async resolveAddressPoints(list, styleId) {
      const points = [];
      for (let index = 0; index < list.length; index += 1) {
        const item = list[index];
        let latitude = Number(item.latitude);
        let longitude = Number(item.longitude);
        if (!latitude || !longitude) {
          try {
            const address = [item.province, item.city, item.district, item.detailedAddress].filter(Boolean).join('');
            const { result } = await geocoder({ address });
            latitude = result.location.lat;
            longitude = result.location.lng;
          } catch (error) {
            console.error('地址解析失败', error);
            continue;
          }
        }
        points.push({
          id: `${styleId}-${item.sortId == null ? index : item.sortId}`,
          styleId,
          sortId: item.sortId,
          address: item,
          position: new TMap.LatLng(latitude, longitude)
        });
      }
      return points;
    },
    driverPoint() {
      const position = this.orderDetails.position;
      if (!position || !Number(position.latitude) || !Number(position.longitude)) return null;
      return {
        id: 'driver',
        styleId: 'driver',
        position: new TMap.LatLng(Number(position.latitude), Number(position.longitude))
      };
    },
    // 到达、开始或完成装卸货时，获取当前操作地点及对应状态信息。
    getOperationStatusPoint() {
      const currentNode = this.trackList[0] || {};
      if (this.isAllLoadingCompleted()) return null;
      const receivingItems = Array.isArray(this.orderDetails.receivingLocationItems)
        ? this.orderDetails.receivingLocationItems
        : [];
      // 完成某站卸货并前往下一站时，已卸货地址统一展示“已签收”，不保留操作中气泡。
      if (currentNode.nodeCode === 'completeDischarge'
        && this.orderDetails.orderLinkCode === 'leavePhoto'
        && receivingItems.length) return null;
      const isArriveDelivery = ['arriveDelivery', 'beginningLoading','completionLoading']
        .includes(currentNode.nodeCode);
      const isArriveUnloading = ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge']
        .includes(currentNode.nodeCode);
      const code = isArriveDelivery || isArriveUnloading
        ? currentNode.nodeCode
        : (this.orderDetails.orderLinkCode || currentNode.nodeCode);
      const loadingCodes = ['arriveDelivery', 'beginningLoading', 'completionLoading'];
      const unloadingCodes = ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'];
      const isLoading = loadingCodes.includes(code);
      const isUnloading = unloadingCodes.includes(code);
      if (!isLoading && !isUnloading) return null;

      const orderItems = isLoading
        ? this.orderDetails.shippingLocationItems
        : (this.orderDetails.receivingLocationItems || this.orderDetails.unloadingLocationItems);
      const nodeItems = isLoading
        ? currentNode.shippingLocationItems
        : (currentNode.receivingLocationItems || currentNode.unloadingLocationItems);
      const items = Array.isArray(orderItems) && orderItems.length ? orderItems : nodeItems;
      const addressList = isLoading ? this.loadingAddressList : this.unloadingAddressList;
      let operationAddress;
      if (isArriveDelivery || isArriveUnloading) {
        // 到达装卸货地时必须通过定位记录坐标匹配地址，防止多地址场景气泡错位。
        const isLastAddressOperation = Array.isArray(items)
          && items.length === addressList.length;
        const isLeavingCompletedUnloading = isUnloading
          && currentNode.nodeCode === 'completeDischarge'
          && this.orderDetails.orderLinkCode === 'leavePhoto';
        // 最后一个地址操作或完成卸货后离场时，sortId 最大项是司机最近记录的地址。
        const locationItems = Array.isArray(items)
          && (isLastAddressOperation || isLeavingCompletedUnloading)
          ? items.slice().sort((a, b) => Number(b.sortId || 0) - Number(a.sortId || 0)).slice(0, 1)
          : (Array.isArray(items) ? items.slice(0, 1) : []);
        operationAddress = locationItems.reduce((matched, item) => matched || addressList.find(address => (
          Number(item.addrLatitude) === Number(address.latitude)
          && Number(item.addrLongitude) === Number(address.longitude)
        )), null);
        if (!operationAddress) return null;
      } else {
        // 其他装卸货节点沿用定位记录数量推断当前操作地址。
        const addressIndex = Array.isArray(items) && items.length ? items.length - 1 : 0;
        operationAddress = addressList[addressIndex];
      }
      const latitude = Number(operationAddress && operationAddress.latitude);
      const longitude = Number(operationAddress && operationAddress.longitude);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
      return {
        id: 'current-operation-status',
        styleId: isLoading ? 'loading' : 'unloading',
        position: new TMap.LatLng(latitude, longitude),
        code,
        statusText: currentNode.nodeName || {
          arriveDelivery: '到达装货地',
          beginningLoading: '开始装货',
          completionLoading: '完成装货',
          arriveUploads: '到达卸货地',
          arriveReceiving: '开始卸货',
          breakBulk: '卸货中',
          completeDischarge: '完成卸货'
        }[code],
        address: (operationAddress && operationAddress.factoryName?operationAddress.factoryName:operationAddress.title) || ''
      };
    },
    // 多装货地址处于装货相关阶段时，根据装货定位记录标识已经完成装货的地址。
    getLoadedAddressStatusPoints(loadingPoints, operationStatusPoint) {
      const currentNode = this.trackList[0] || {};
      const visibleCodes = ['leavePhoto', 'arriveDelivery', 'beginningLoading', 'completionLoading'];
      const shippingItems = Array.isArray(this.orderDetails.shippingLocationItems)
        ? this.orderDetails.shippingLocationItems
        : [];
      if (this.isAllLoadingCompleted()
        || this.loadingAddressList.length <= 1
        || !visibleCodes.includes(currentNode.nodeCode)
        || !shippingItems.length) {
        return [];
      }

      const matchedPoints = [];
      shippingItems.forEach(item => {
        const itemLatitude = Number(item.addrLatitude);
        const itemLongitude = Number(item.addrLongitude);
        if (!Number.isFinite(itemLatitude) || !Number.isFinite(itemLongitude)
          || !itemLatitude || !itemLongitude) return;
        const point = loadingPoints.find(candidate => (
          itemLatitude === Number(candidate.address && candidate.address.latitude)
          && itemLongitude === Number(candidate.address && candidate.address.longitude)
        ));
        if (point && !matchedPoints.includes(point)) matchedPoints.push(point);
      });
      // 兼容旧定位记录缺少地址坐标的情况，此时按记录数量回退到地址顺序。
      const loadedPoints = matchedPoints.length
        ? matchedPoints
        : loadingPoints.slice(0, Math.min(shippingItems.length, loadingPoints.length));
      return loadedPoints.map(point => {
        // 正在操作的装货地继续展示原节点气泡，避免被“已装货”气泡覆盖。
        if (operationStatusPoint
          && point.position.getLat() === operationStatusPoint.position.getLat()
          && point.position.getLng() === operationStatusPoint.position.getLng()) return null;
        return {
          position: point.position,
          address: (point.address && (point.address.factoryName || point.address.title)) || ''
        };
      }).filter(Boolean);
    },
    // 离开装货地且定位记录覆盖全部装货地址时，订单已经进入前往卸货地阶段。
    isAllLoadingCompleted() {
      const currentNode = this.trackList[0] || {};
      const shippingItems = Array.isArray(this.orderDetails.shippingLocationItems)
        ? this.orderDetails.shippingLocationItems
        : [];
      return currentNode.nodeCode === 'leavePhoto'
        && this.loadingAddressList.length > 0
        && shippingItems.length === this.loadingAddressList.length;
    },
    // 卸货操作期间识别当前地址之外已经签收的地址。
    getSignedAddressStatusPoints(unloadingPoints, operationStatusPoint) {
      const currentNode = this.trackList[0] || {};
      const visibleCodes = ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'];
      const receivingItems = Array.isArray(this.orderDetails.receivingLocationItems)
        ? this.orderDetails.receivingLocationItems
        : [];
      const isLastUnloadingOperation = visibleCodes.includes(currentNode.nodeCode)
        && receivingItems.length === this.unloadingAddressList.length;
      const isLeavingCompletedUnloading = currentNode.nodeCode === 'completeDischarge'
        && this.orderDetails.orderLinkCode === 'leavePhoto';
      const sortedReceivingItems = receivingItems.slice()
        .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0));
      // 前往下一卸货地时全部记录均已完成；仍在最后一站操作时仅排除当前地址。
      const signedItems = isLeavingCompletedUnloading
        ? sortedReceivingItems
        : isLastUnloadingOperation
          ? sortedReceivingItems.slice(0, -1)
        : receivingItems.slice(1);
      if (!visibleCodes.includes(currentNode.nodeCode) || !signedItems.length) return [];

      const matchedPoints = [];
      signedItems.forEach(item => {
        const itemLatitude = Number(item.addrLatitude);
        const itemLongitude = Number(item.addrLongitude);
        if (!Number.isFinite(itemLatitude) || !Number.isFinite(itemLongitude)
          || !itemLatitude || !itemLongitude) return;
        const point = unloadingPoints.find(candidate => (
          itemLatitude === candidate.position.getLat()
          && itemLongitude === candidate.position.getLng()
        ));
        if (point && !matchedPoints.includes(point)) matchedPoints.push(point);
      });
      // 兼容旧定位记录缺少地址坐标的情况，并排除当前正在操作的卸货地。
      const signedPoints = matchedPoints.length
        ? matchedPoints
        : unloadingPoints.filter(point => {
          if (!operationStatusPoint) return true;
          return point.position.getLat() !== operationStatusPoint.position.getLat()
            || point.position.getLng() !== operationStatusPoint.position.getLng();
        }).slice(0, signedItems.length);
      return signedPoints.map(point => ({
        position: point.position,
        address: (point.address && (point.address.factoryName || point.address.title)) || ''
      }));
    },
    trackPoints() {
      const list = Array.isArray(this.orderDetails.tmsOrderPosition)
        ? this.orderDetails.tmsOrderPosition.slice()
        : [];
      return list
        .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0))
        .filter(item => Number(item.latitude) && Number(item.longitude))
        .map((item, index) => ({
          id: `track-${index}`,
          position: new TMap.LatLng(Number(item.latitude), Number(item.longitude))
        }));
    },
    drawMarkers(geometries) {
      if (!geometries.length) return;
      this.markerLayer = new TMap.MultiMarker({
        id: 'share-order-markers',
        map: this.map,
        styles: {
          driver: new TMap.MarkerStyle({
            width: 50,
            height: 58,
            anchor: { x: 25, y: 24 },
            src: require('@/assets/image/driver-position-icon.png')
          }),
          loading: new TMap.MarkerStyle({
            width: 50,
            height: 52,
            src: require('@/assets/image/start-icon.png')
          }),
          unloading: new TMap.MarkerStyle({
            width: 50,
            height: 52,
            src: require('@/assets/image/end-address-icon.png')
          })
        },
        geometries
      });
    },
    async drawRoutes(loadingPoints, unloadingPoints, driver, track) {
      const currentNode = this.trackList[0] || {};
      const trackCode = currentNode.nodeCode || currentNode.node;
      const code = this.orderDetails.orderLinkCode || trackCode;
      const isAccepted = trackCode === '接单';
      const isLoadingOperationRoute = ['arriveDelivery', 'beginningLoading', 'completionLoading']
        .includes(currentNode.nodeCode);
      const isArriveUnloadingRoute = ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge']
        .includes(currentNode.nodeCode);
      const isHeadingToLoading = currentNode.nodeCode === '前往装货地'
        || currentNode.node === '前往装货地';
      const allLoadingCompleted = this.isAllLoadingCompleted();
      const isMovingToNextLoading = currentNode.nodeCode === 'leavePhoto'
        && (Array.isArray(this.orderDetails.shippingLocationItems)
          ? this.orderDetails.shippingLocationItems.length
          : 0) !== this.loadingAddressList.length;
      const isHeadingToFirstUnloading = allLoadingCompleted
        || (this.orderDetails.orderLinkCode !== 'start'
        && currentNode.nodeCode === 'leavePhoto'
        && this.orderDetails.receivingLocationItems === null);
      const receivingLocationList = Array.isArray(this.orderDetails.receivingLocationItems)
        ? this.orderDetails.receivingLocationItems
        : [];
      const isLastUnloadingArrival = ['arriveUploads','arriveReceiving','breakBulk','completeDischarge'].includes(currentNode.nodeCode)
        && this.unloadingAddressList.length > 0
        && receivingLocationList.length === this.unloadingAddressList.length;
      const isHeadingToNextUnloading = currentNode.nodeCode === 'completeDischarge'
        && this.orderDetails.orderLinkCode === 'leavePhoto'
        && receivingLocationList.length > 0
        && receivingLocationList.length < this.unloadingAddressList.length;
      const shippingLocationCount = Array.isArray(this.orderDetails.shippingLocationItems)
        ? this.orderDetails.shippingLocationItems.length
        : 0;
      const isLastLoadingArrival = ['arriveDelivery','beginningLoading','completionLoading'].includes(currentNode.nodeCode)
        && this.loadingAddressList.length > 0
        && shippingLocationCount === this.loadingAddressList.length;
      const geometries = [];

      // 装卸货操作阶段只显示当前地点状态，不绘制路线规划线条。
      const noRouteCodes = [
        'arriveDelivery', 'beginningLoading', 'completionLoading',
        'arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'
      ];
      if (!isAccepted && !isLoadingOperationRoute && !isArriveUnloadingRoute && !isLastLoadingArrival
        && noRouteCodes.includes(code)) return;

      // 接单后优先从司机位置出发；缺少司机定位时仍展示全部装卸货地之间的路线。
      if (isAccepted && !isLastLoadingArrival) {
        const routePoints = (driver ? [driver.position] : []).concat(
          loadingPoints.map(item => item.position),
          unloadingPoints.map(item => item.position)
        );
        if (routePoints.length > 1) {
          try {
            const route = await this.requestRoute(routePoints);
            geometries.push({
              id: 'accepted-route',
              styleId: 'accepted',
              paths: route.paths
            });
          } catch (error) {
            console.error('接单路线规划失败', error);
          }
        }
      } else if (isLastLoadingArrival && loadingPoints.length) {
        const sortedShippingItems = this.orderDetails.shippingLocationItems.slice()
          .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0));
        const unusedLoadingPoints = loadingPoints.slice();
        const matchedLoadingPoints = sortedShippingItems.map(item => {
          const pointIndex = unusedLoadingPoints.findIndex(point => (
            Number(item.addrLatitude) === point.position.getLat()
            && Number(item.addrLongitude) === point.position.getLng()
          ));
          return pointIndex >= 0 ? unusedLoadingPoints.splice(pointIndex, 1)[0] : null;
        }).filter(Boolean);
        // 最后一个装货地操作期间，按定位记录 sortId 顺序连接已装货地与当前装货地。
        const operatedLoadingPoints = matchedLoadingPoints.length === loadingPoints.length
          ? matchedLoadingPoints
          : loadingPoints;
        if (operatedLoadingPoints.length > 1) {
          try {
            const travelledRoute = await this.requestRoute(
              operatedLoadingPoints.map(item => item.position)
            );
            geometries.push({
              id: 'completed-loading-route',
              styleId: 'operated-loading',
              paths: travelledRoute.paths
            });
          } catch (error) {
            console.error('装货地之间路线规划失败', error);
          }
        }
        const currentLoadingPoint = operatedLoadingPoints[operatedLoadingPoints.length - 1].position;
        const remainingPoints = [currentLoadingPoint].concat(
          unloadingPoints.map(item => item.position)
        );
        if (remainingPoints.length > 1) {
          try {
            const remainingRoute = await this.requestRoute(remainingPoints);
            geometries.push({
              id: 'last-loading-to-unloading-route',
              styleId: 'next-loading',
              paths: remainingRoute.paths
            });
          } catch (error) {
            console.error('最后装货地到卸货地路线规划失败', error);
          }
        }
      } else if (isMovingToNextLoading && driver && loadingPoints.length) {
        const orderItems = Array.isArray(this.orderDetails.shippingLocationItems)
          && this.orderDetails.shippingLocationItems.length
          ? this.orderDetails.shippingLocationItems
          : currentNode.shippingLocationItems;
        const shippingItems = Array.isArray(orderItems) ? orderItems : [];
        const completedItem = shippingItems[0];
        const completedLoadingPoint = completedItem
          ? loadingPoints.find(point => (
            Number(completedItem.addrLatitude) === point.position.getLat()
            && Number(completedItem.addrLongitude) === point.position.getLng()
          ))
          : null;
        // 未完成装货地以地址坐标未出现在装货定位记录中为准，并保持地址列表原有顺序。
        const pendingLoadingPoints = loadingPoints.filter(point => !shippingItems.some(item => (
          Number(item.addrLatitude) === point.position.getLat()
          && Number(item.addrLongitude) === point.position.getLng()
        )));

        if (completedLoadingPoint) {
          try {
            const travelledRoute = await this.requestRoute([
              completedLoadingPoint.position,
              driver.position
            ]);
            geometries.push({
              id: 'completed-loading-to-driver-route',
              styleId: 'operated-loading',
              paths: travelledRoute.paths
            });
          } catch (error) {
            console.error('已完成装货地到司机位置路线规划失败', error);
          }
        }
        if (pendingLoadingPoints.length) {
          try {
            // 剩余线路从司机位置开始，依次经过所有未完成装货地和卸货地。
            const remainingPoints = [driver.position].concat(
              pendingLoadingPoints.map(item => item.position),
              unloadingPoints.map(item => item.position)
            );
            const [remainingRoute, distanceRoute] = await Promise.all([
              this.requestRoute(remainingPoints),
              this.requestRoute([driver.position, pendingLoadingPoints[0].position])
            ]);
            geometries.push({
              id: 'driver-through-pending-loading-to-unloading-route',
              styleId: 'next-loading',
              paths: remainingRoute.paths
            });
            this.showDistance(driver.position, distanceRoute, '装货地');
          } catch (error) {
            console.error('司机经未完成装货地到卸货地路线规划失败', error);
          }
        }
      } else if (!isArriveUnloadingRoute && isLastUnloadingArrival) {
        const routePoints = loadingPoints
          .concat(unloadingPoints)
          .map(item => item.position);
        if (routePoints.length > 1) {
          try {
            const route = await this.requestRoute(routePoints);
            geometries.push({
              id: 'all-locations-completed-route',
              styleId: 'arrived-unloading',
              paths: route.paths
            });
          } catch (error) {
            console.error('全部装卸货地路线规划失败', error);
          }
        }
      } else if (isHeadingToNextUnloading
        && driver
        && unloadingPoints.length) {
        const getSortedLocationPoints = items => items.slice()
          .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0))
          .map(item => {
            const latitude = Number(item.addrLatitude);
            const longitude = Number(item.addrLongitude);
            return Number.isFinite(latitude) && Number.isFinite(longitude)
              ? new TMap.LatLng(latitude, longitude)
              : null;
          })
          .filter(Boolean);
        const operatedLoadingPoints = getSortedLocationPoints(
          Array.isArray(this.orderDetails.shippingLocationItems)
            ? this.orderDetails.shippingLocationItems
            : []
        );
        const operatedUnloadingPoints = getSortedLocationPoints(receivingLocationList);
        const nextUnloadingPoint = unloadingPoints.find(point => !receivingLocationList.some(item => (
          Number(item.addrLatitude) === point.position.getLat()
          && Number(item.addrLongitude) === point.position.getLng()
        ))) || unloadingPoints[receivingLocationList.length];
        if (nextUnloadingPoint) {
          // 已行驶线路严格按装货、卸货定位记录的 sortId 顺序连接到司机当前位置。
          const travelledPoints = (operatedLoadingPoints.length
            ? operatedLoadingPoints
            : loadingPoints.map(item => item.position))
            .concat(operatedUnloadingPoints, driver.position);
          if (travelledPoints.length > 1) {
            try {
              const travelledRoute = await this.requestRoute(travelledPoints);
              geometries.push({
                id: 'operated-locations-to-driver-route',
                styleId: 'loading-to-driver',
                paths: travelledRoute.paths
              });
            } catch (error) {
              console.error('已操作地点到司机位置路线规划失败', error);
            }
          }
          try {
            const remainingRoute = await this.requestRoute([
              driver.position,
              nextUnloadingPoint.position
            ]);
            geometries.push({
              id: 'driver-to-next-unloading-route',
              styleId: 'first-unloading',
              paths: remainingRoute.paths
            });
            this.showDistance(driver.position, remainingRoute, '卸货地');
          } catch (error) {
            console.error('司机前往下一卸货地路线规划失败', error);
          }
        }
      } else if (isHeadingToFirstUnloading && driver && unloadingPoints.length) {
        if (loadingPoints.length) {
          try {
            const shippingItems = Array.isArray(this.orderDetails.shippingLocationItems)
              ? this.orderDetails.shippingLocationItems
              : [];
            const unusedLoadingPoints = loadingPoints.slice();
            // 定位记录首项是最后操作地，倒序后才能还原实际装货顺序并连接司机当前位置。
            const operatedLoadingPoints = shippingItems.slice().reverse().map(item => {
              const pointIndex = unusedLoadingPoints.findIndex(point => (
                Number(item.addrLatitude) === point.position.getLat()
                && Number(item.addrLongitude) === point.position.getLng()
              ));
              return pointIndex >= 0
                ? unusedLoadingPoints.splice(pointIndex, 1)[0].position
                : null;
            }).filter(Boolean);
            const travelledPoints = (operatedLoadingPoints.length
              ? operatedLoadingPoints
              : loadingPoints.map(item => item.position)).concat(driver.position);
            const travelledRoute = await this.requestRoute(travelledPoints);
            geometries.push({
              id: 'loading-to-driver-route',
              styleId: 'loading-to-driver',
              paths: travelledRoute.paths
            });
          } catch (error) {
            console.error('装货地到司机位置路线规划失败', error);
          }
        }
        try {
          const remainingPoints = [driver.position].concat(
            unloadingPoints.map(item => item.position)
          );
          const [remainingRoute, distanceRoute] = await Promise.all([
            this.requestRoute(remainingPoints),
            this.requestRoute([driver.position, unloadingPoints[0].position])
          ]);
          geometries.push({
            id: 'first-unloading-route',
            styleId: 'first-unloading',
            paths: remainingRoute.paths
          });
          this.showDistance(driver.position, distanceRoute, '卸货地');
        } catch (error) {
          console.error('司机前往第一个卸货地路线规划失败', error);
        }
      } else if (isArriveUnloadingRoute) {
        const operationStatusPoint = this.getOperationStatusPoint();
        if (operationStatusPoint) {
          const receivingItems = Array.isArray(this.orderDetails.receivingLocationItems)
            ? this.orderDetails.receivingLocationItems
            : [];
          const currentUnloadingPoint = operationStatusPoint.position;
          const operatedItems = receivingItems.slice(1);
          let operatedUnloadingPoints = unloadingPoints.filter(point => operatedItems.some(item => (
            Number(item.addrLatitude) === point.position.getLat()
            && Number(item.addrLongitude) === point.position.getLng()
          )));
          // 旧定位记录无坐标时，按记录数量回退，并排除 receivingLocationItems[0] 对应的当前操作地。
          if (!operatedUnloadingPoints.length && operatedItems.length) {
            operatedUnloadingPoints = unloadingPoints
              .filter(point => (
                point.position.getLat() !== currentUnloadingPoint.getLat()
                || point.position.getLng() !== currentUnloadingPoint.getLng()
              ))
              .slice(0, operatedItems.length);
          }
          const pendingUnloadingPoints = unloadingPoints.filter(point => {
            const isCurrentPoint = point.position.getLat() === currentUnloadingPoint.getLat()
              && point.position.getLng() === currentUnloadingPoint.getLng();
            const isOperatedPoint = operatedUnloadingPoints.some(operatedPoint => (
              operatedPoint.position.getLat() === point.position.getLat()
              && operatedPoint.position.getLng() === point.position.getLng()
            ));
            return !isCurrentPoint && !isOperatedPoint;
          });
          const isLastUnloadingOperation = [
            'arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'
          ].includes(currentNode.nodeCode)
            && receivingItems.length === this.unloadingAddressList.length;
          const getSortedLocationPoints = items => items.slice()
            .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0))
            .map(item => {
              const latitude = Number(item.addrLatitude);
              const longitude = Number(item.addrLongitude);
              return Number.isFinite(latitude) && Number.isFinite(longitude)
                ? new TMap.LatLng(latitude, longitude)
                : null;
            })
            .filter(Boolean);
          // 操作最后一个卸货地时，卸货定位必须按 sortId 升序还原已行驶线路。
          const travelledPoints = isLastUnloadingOperation
            ? getSortedLocationPoints(Array.isArray(this.orderDetails.shippingLocationItems)
              ? this.orderDetails.shippingLocationItems
              : []).concat(getSortedLocationPoints(receivingItems))
            : loadingPoints
              .map(item => item.position)
              .concat(
                operatedUnloadingPoints.map(item => item.position),
                currentUnloadingPoint
              );
          if (travelledPoints.length > 1) {
            try {
              const travelledRoute = await this.requestRoute(travelledPoints);
              geometries.push({
                id: isLastUnloadingOperation
                  ? 'sorted-loading-to-receiving-route'
                  : 'loading-through-operated-to-current-unloading-route',
                styleId: 'arrived-unloading',
                paths: travelledRoute.paths
              });
            } catch (error) {
              console.error('已操作装卸货地路线规划失败', error);
            }
          }
          const remainingPoints = [currentUnloadingPoint].concat(
            pendingUnloadingPoints.map(item => item.position)
          );
          if (!isLastUnloadingOperation && remainingPoints.length > 1) {
            try {
              const remainingRoute = await this.requestRoute(remainingPoints);
              geometries.push({
                id: 'remaining-unloading-route',
                styleId: 'remaining-unloading',
                paths: remainingRoute.paths
              });
            } catch (error) {
              console.error('当前卸货地到其他卸货地路线规划失败', error);
            }
          }
        }
      } else if (isLoadingOperationRoute) {
        const operationStatusPoint = this.getOperationStatusPoint();
        if (operationStatusPoint) {
          const shippingItems = Array.isArray(this.orderDetails.shippingLocationItems)
            ? this.orderDetails.shippingLocationItems
            : [];
          const currentLoadingPoint = operationStatusPoint.position;
          const operatedItems = shippingItems.slice(1);
          let operatedPoints = loadingPoints.filter(point => operatedItems.some(item => (
            Number(item.addrLatitude) === point.position.getLat()
            && Number(item.addrLongitude) === point.position.getLng()
          )));
          // 旧定位记录无坐标时，按记录数量回退，并排除 shippingLocationItems[0] 对应的当前操作地。
          if (!operatedPoints.length && operatedItems.length) {
            operatedPoints = loadingPoints
              .filter(point => (
                point.position.getLat() !== currentLoadingPoint.getLat()
                || point.position.getLng() !== currentLoadingPoint.getLng()
              ))
              .slice(0, operatedItems.length);
          }
          const travelledPoints = operatedPoints
            .map(point => point.position)
            .concat(currentLoadingPoint);
          if (travelledPoints.length > 1) {
            try {
              const travelledRoute = await this.requestRoute(travelledPoints);
              geometries.push({
                id: 'operated-to-current-loading-route',
                styleId: 'operated-loading',
                paths: travelledRoute.paths
              });
            } catch (error) {
              console.error('已操作装货地到当前装货地路线规划失败', error);
            }
          }
          // 操作最后一个装货地时直接前往卸货地；否则先经过尚未操作的下一装货地。
          const currentShippingItem = shippingItems[0];
          const isFinalLoadingOperation = ['arriveDelivery', 'beginningLoading']
            .includes(currentNode.nodeCode)
            && shippingItems.length === this.loadingAddressList.length;
          const nextLoadingPoint = !isFinalLoadingOperation && currentShippingItem
            ? loadingPoints.find(point => !shippingItems.some(item => (
              Number(item.addrLatitude) === point.position.getLat()
              && Number(item.addrLongitude) === point.position.getLng()
            )))
            : null;
          const remainingPoints = [currentLoadingPoint]
            .concat(
              nextLoadingPoint ? [nextLoadingPoint.position] : [],
              unloadingPoints.map(point => point.position)
            );
          if (remainingPoints.length > 1) {
            try {
              const remainingRoute = await this.requestRoute(remainingPoints);
              geometries.push({
                id: 'current-loading-through-next-to-unloading-route',
                styleId: 'next-loading',
                paths: remainingRoute.paths
              });
            } catch (error) {
              console.error('当前装货地经下一装货地到卸货地路线规划失败', error);
            }
          }
        }
      } else if (trackCode === 'receipt' || code === 'receipt') {
        // 签收后分别按装货、卸货定位记录的 sortId 升序还原实际操作顺序。
        const getOperatedPoints = (items, points) => {
          const unusedPoints = points.slice();
          return (Array.isArray(items)
            ? items.slice().sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0))
            : []).map(item => {
            const latitude = Number(item.addrLatitude);
            const longitude = Number(item.addrLongitude);
            let pointIndex = unusedPoints.findIndex(point => (
              Number.isFinite(latitude)
              && Number.isFinite(longitude)
              && latitude === point.position.getLat()
              && longitude === point.position.getLng()
            ));
            if (pointIndex < 0) pointIndex = 0;
            return pointIndex >= 0 ? unusedPoints.splice(pointIndex, 1)[0].position : null;
          }).filter(Boolean);
        };
        const operatedLoadingPoints = getOperatedPoints(
          this.orderDetails.shippingLocationItems,
          loadingPoints
        );
        const operatedUnloadingPoints = getOperatedPoints(
          this.orderDetails.receivingLocationItems,
          unloadingPoints
        );
        const routePoints = (operatedLoadingPoints.length
          ? operatedLoadingPoints
          : loadingPoints.map(item => item.position))
          .concat(operatedUnloadingPoints.length
            ? operatedUnloadingPoints
            : unloadingPoints.map(item => item.position));
        if (routePoints.length > 1) {
          try {
            const route = await this.requestRoute(routePoints);
            geometries.push({
              id: 'signed-route',
              styleId: 'signed',
              paths: route.paths
            });
          } catch (error) {
            console.error('已操作装卸货地路线规划失败', error);
          }
        }
      } else {
        if (track.length > 1) {
          geometries.push({
            id: 'travelled-track',
            styleId: 'travelled',
            paths: track.map(item => item.position)
          });
        }

        if ((isHeadingToLoading || code === 'start') && driver) {
          const targetPoint = this.getNextLoadingPoint(loadingPoints);
          if (targetPoint) {
            try {
              // 主线路覆盖司机、全部装货地和卸货地；距离气泡仅计算司机到下一装货地。
              const routePoints = [driver.position].concat(
                loadingPoints.map(item => item.position),
                unloadingPoints.map(item => item.position)
              );
              const [route, distanceRoute] = await Promise.all([
                this.requestRoute(routePoints),
                this.requestRoute([driver.position, targetPoint])
              ]);
              geometries.push({
                id: 'remaining-route',
                styleId: 'heading-to-loading',
                paths: route.paths
              });
              this.showDistance(driver.position, distanceRoute, '装货地');
            } catch (error) {
              console.error('路线规划失败', error);
            }
          }
        } else if (code === 'leavePhoto' && driver) {
          const targetPoint = this.getNextUnloadingPoint(unloadingPoints);
          if (targetPoint) {
            try {
              const route = await this.requestRoute([driver.position, targetPoint]);
              geometries.push({
                id: 'remaining-route',
                styleId: 'remaining',
                paths: route.paths
              });
              this.showDistance(driver.position, route, '卸货地');
            } catch (error) {
              console.error('路线规划失败', error);
            }
          }
        } else {
          const routePoints = loadingPoints.concat(unloadingPoints).map(item => item.position);
          if (routePoints.length > 1) {
            try {
              const route = await this.requestRoute(routePoints);
              geometries.push({
                id: 'remaining-route',
                styleId: Number(this.orderDetails.state) >= 6 ? 'travelled' : 'remaining',
                paths: route.paths
              });
            } catch (error) {
              console.error('路线规划失败', error);
            }
          }
        }
      }

      if (!geometries.length) return;
      this.polylineLayer = new TMap.MultiPolyline({
        id: 'share-order-lines',
        map: this.map,
        styles: {
          travelled: new TMap.PolylineStyle({
            color: '#c9c1bb',
            width: 9,
            lineCap: 'round'
          }),
          remaining: new TMap.PolylineStyle({
            color: '#599fed',
            width: 9,
            borderWidth: 1,
            borderColor: '#ecf2fe',
            lineCap: 'round',
            showArrow: true
          }),
          signed: new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          accepted: new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          'heading-to-loading': new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          arrived: new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          'operated-loading': new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          'next-loading': new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          'driver-to-next-loading': new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          'loading-to-driver': new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          'first-unloading': new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          'arrived-unloading': new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          'remaining-unloading': new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          })
        },
        geometries
      });
    },
    getNextLoadingPoint(loadingPoints) {
      const completed = this.trackList.filter(item => item.nodeCode === 'completionLoading').length;
      const sortedPoints = loadingPoints.slice().sort((a, b) => (
        Number((a.address && a.address.sortId) || a.sortId || 0)
        - Number((b.address && b.address.sortId) || b.sortId || 0)
      ));
      const nextPoint = sortedPoints[Math.min(completed, Math.max(sortedPoints.length - 1, 0))];
      return nextPoint ? nextPoint.position : null;
    },
    getNextUnloadingPoint(unloadingPoints) {
      const receivingItems = Array.isArray(this.orderDetails.receivingLocationItems)
        ? this.orderDetails.receivingLocationItems
        : [];
      const completed = receivingItems.length
        || this.trackList.filter(item => /completionUnloading|签收|回单/.test(item.nodeCode || '')).length;
      // 下一装卸货地始终按地址 sortId 升序选取，避免接口数组顺序变化导致目标点跳动。
      const sortedPoints = unloadingPoints.slice().sort((a, b) => (
        Number((a.address && a.address.sortId) || a.sortId || 0)
        - Number((b.address && b.address.sortId) || b.sortId || 0)
      ));
      const nextPoint = sortedPoints[Math.min(completed, Math.max(sortedPoints.length - 1, 0))];
      return nextPoint ? nextPoint.position : null;
    },
    isUnloadingStage() {
      const code = String(this.orderDetails.orderLinkCode || '').toLowerCase();
      if (/unload|receiv|sign|receipt/.test(code)) return true;
      const completedLoading = this.trackList.filter(item => item.nodeCode === 'completionLoading').length;
      return this.loadingAddressList.length > 0 && completedLoading >= this.loadingAddressList.length;
    },
    pendingStops(loadingPoints, unloadingPoints) {
      if (this.isUnloadingStage()) {
        const completed = this.trackList.filter(item => /completionUnloading|签收|回单/.test(item.nodeCode || '')).length;
        return unloadingPoints.slice(Math.min(completed, unloadingPoints.length)).map(item => item.position);
      }
      const completed = this.trackList.filter(item => item.nodeCode === 'completionLoading').length;
      return loadingPoints
        .slice(Math.min(completed, loadingPoints.length))
        .concat(unloadingPoints)
        .map(item => item.position);
    },
    // 腾讯路线规划同一秒请求过多会失败，并发规划需排队并间隔 500ms。
    enqueueRouteRequest() {
      const previous = this.routeRequestQueue || Promise.resolve();
      let release;
      const current = new Promise(resolve => {
        release = resolve;
      });
      this.routeRequestQueue = previous.catch(() => {}).then(async () => {
        const wait = this.lastRouteRequestAt
          ? Math.max(0, 500 - (Date.now() - this.lastRouteRequestAt))
          : 0;
        if (wait) await new Promise(resolve => setTimeout(resolve, wait));
        this.lastRouteRequestAt = Date.now();
        release();
      });
      return current;
    },
    async requestRoute(points) {
      await this.enqueueRouteRequest();
      const coordinates = points.map(point => {
        const latitude = typeof point.getLat === 'function' ? point.getLat() : point.lat;
        const longitude = typeof point.getLng === 'function' ? point.getLng() : point.lng;
        return `${latitude},${longitude}`;
      });
      const params = {
        from: coordinates[0],
        to: coordinates[coordinates.length - 1]
      };
      if (coordinates.length > 2) params.waypoints = coordinates.slice(1, -1).join(';');
      const result = await directionDriving(params);
      const route = result.result.routes[0];
      const coords = route.polyline.slice();
      for (let index = 2; index < coords.length; index += 1) {
        coords[index] = Number(coords[index - 2]) + Number(coords[index]) / 1000000;
      }
      const paths = [];
      for (let index = 0; index < coords.length; index += 2) {
        paths.push(new TMap.LatLng(coords[index], coords[index + 1]));
      }
      return {
        paths,
        distance: route.distance,
        duration: route.duration
      };
    },
    showDistance(position, route, targetName = '装货地') {
      if (this.distanceOverlay) this.distanceOverlay.destroy();
      this.distanceOverlay = new Donut({
        map: this.map,
        position,
        isShowPickup: true,
        data: {
          text: `司机距离${targetName}`,
          contentText: '距离',
          meil: (Number(route.distance || 0) / 1000).toFixed(2),
          time: formatMinutes(Number(route.duration || 0))
        }
      });
    },
    showAcceptedOrder(position) {
      if (this.distanceOverlay) this.distanceOverlay.destroy();
      this.distanceOverlay = new Donut({
        map: this.map,
        position,
        isShowPickup: false,
        deliveryTime: this.formatPickupCountdown(this.orderDetails.deliveryTime, this.currentTimestamp),
        data: {
          text: '司机已接单',
          contentText: ''
        }
      });
    },
    // 在装卸货 Marker 上方展示当前状态和地址。
    showOperationStatus(point) {
      if (this.distanceOverlay) this.distanceOverlay.destroy();
      this.distanceOverlay = new Donut({
        map: this.map,
        position: point.position,
        isShowPickup: false,
        offsetY: 30,
        code: point.code,
        data: {
          text: point.statusText,
          contentText: point.address
        }
      });
    },
    showLoadedAddressStatuses(points) {
      this.destroyLoadedAddressOverlays();
      this.loadedAddressOverlays = points.map(point => new Donut({
        map: this.map,
        position: point.position,
        isShowPickup: false,
        offsetY: 30,
        code: 'completionLoading',
        data: {
          text: '已装货',
          contentText: point.address
        }
      }));
    },
    destroyLoadedAddressOverlays() {
      this.loadedAddressOverlays.forEach(overlay => overlay.destroy());
      this.loadedAddressOverlays = [];
    },
    showSignedAddressStatuses(points) {
      this.destroySignedAddressOverlays();
      this.signedAddressOverlays = points.map(point => new Donut({
        map: this.map,
        position: point.position,
        isShowPickup: false,
        offsetY: 30,
        code: 'completeDischarge',
        data: {
          text: '已签收',
          contentText: point.address
        }
      }));
    },
    destroySignedAddressOverlays() {
      this.signedAddressOverlays.forEach(overlay => overlay.destroy());
      this.signedAddressOverlays = [];
    },
    fitMap(points) {
      if (!points.length || !this.map) return;
      const bounds = new TMap.LatLngBounds();
      points.forEach(item => bounds.extend(item.position));
      const mapElement = document.getElementById('shareOrderMap');
      const mapHeight = mapElement ? mapElement.clientHeight : window.innerHeight;
      const panelTop = this.$refs.floatingPanel
        ? this.$refs.floatingPanel.top
        : this.floatingPanelAnchors[0];

      this.map.fitBounds(bounds, {
        padding: {
          top: 240,
          right: 24,
          bottom: Math.max(mapHeight - panelTop + 16, 16),
          left: 24
        }
      });
    },
    destroyMapLayers() {
      if (this.markerLayer) {
        this.markerLayer.setMap(null);
        this.markerLayer = null;
      }
      if (this.polylineLayer) {
        this.polylineLayer.setMap(null);
        this.polylineLayer = null;
      }
      if (this.distanceOverlay) {
        this.distanceOverlay.destroy();
        this.distanceOverlay = null;
      }
      this.destroyLoadedAddressOverlays();
      this.destroySignedAddressOverlays();
    },
    handleColdData() {
      const shareCode = this.$route.query.shareCode;
      if (!shareCode) {
        Toast.fail('缺少分享码');
        return;
      }
      this.$router.push({
        path: '/shareOrderColdData',
        query: { shareCode }
      });
    },
    formatPickupCountdown(deliveryTime, currentTimestamp = Date.now()) {
      if (!deliveryTime) return '提货时间待定';
      const pickupTime = new Date(String(deliveryTime).replace(/-/g, '/')).getTime();
      if (!Number.isFinite(pickupTime)) return '提货时间待定';
      const remaining = pickupTime - currentTimestamp;
      if (remaining <= 0) return '已超时';
      const totalMinutes = Math.ceil(remaining / 60000);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `剩余${hours}小时${minutes}分钟提货`;
    },
  }
};
</script>

<style scoped lang="scss">
.share-order-page {
  min-height: 100vh;
  overflow-x: hidden;
  background: #f8f8f8;
  color: #241f1b;
  font-family: "Source Han Sans CN", Arial, sans-serif;
}
.map-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 44px);
  contain: layout paint;
}
.navigation-bar {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
  padding: 0 12px;
  box-sizing: border-box;
  background: #fff;
  color: #000;
  font-size: 16px;
}
.back-button {
  width: 44px;
  border: 0;
  background: transparent;
  color: #3d3833;
  font-size: 32px;
  line-height: 36px;
  text-align: left;
}
.nav-placeholder {
  width: 44px;
}
.status-card {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1001;
  width: calc(100% - 24px);
  height: 108px;
  overflow: hidden;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 3px 6px rgba(204, 181, 159, 0.1);
}
.status-card-header {
  height: 30px;
  padding-left: 8px;
  padding-right: 16px;
  color: #FBE2AF;
  background-color: #FFF0D4;
  font-size: 12px;
  line-height: 30px;
  position: relative;
  display: flex;
  justify-content: space-between;
  .order-tab {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: inline-block;
    width: 237px;
    height: 30px;
  }
  .status-card-header-right {
    color: #3D3833;
    text-align: right;
    font-family: "Source Han Sans CN";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.3px;
  }
}
.order-number {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
}
.bee-logo {
display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 4px;
}
.copy-button {
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fbe2af;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 78px;
  .status-card-body-left {
    padding: 36px 0 16px 12px;
  }
}
.status-title {
  font-size: 16px;
  line-height: 24px;
}
.status-badge {
  margin-left: 4px;
  padding: 3px 5px;
  border-radius: 10px;
  background: #ffbd2d;
  color: #fff;
  font-size: 10px;
}
.pickup-time {
  margin-top: 5px;
  color: #85807b;
  font-size: 12px;
  position: relative;
  .pickup-time-tip {
    position: absolute;
    right: 0;
    bottom: calc(100% + 30px);
    padding: 2px 8px;
    border-radius: 2px;
    background: #ff484a;
    color: #ffffff;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    white-space: nowrap;
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 12px;
      border: 5px solid transparent;
      border-top-color: #ff484a;
    }
  }
}
.city-route {
    width: 156px;
    display: flex;
    flex-direction: column;
  background-color: #F8F8F8;
  text-align: center;
  font-size: 14px;
  color: #3D3833;
    text-align: center;
    font-family: "Source Han Sans CN";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    padding: 7px 0;
}
.route-arrow {
  color: #85807b;
}
.driver-card {
  display: flex;
  align-items: center;
  width: calc(100% - 24px);
  height: 72px;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 3px 6px rgba(204, 181, 159, 0.1);
  margin: auto;
}
.driver-copy {
  min-width: 0;
  margin-left: 12px;
}
.driver-name {
  font-size: 14px;
  line-height: 22px;
}
.car-description {
  overflow: hidden;
  color: #3d3833;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sex-tag {
  margin-left: 6px;
  color: #599fed;
  font-size: 12px;
}
.details-panel {
    height: 100%;
  min-height: 0;
  position: relative;
  z-index: 1001;
  border-radius: 16px 16px 0 0;
  background: #fff;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
}
.tabs {
  display: flex;
  width: 100%;
  height: 42px;
  padding-left: 12px;
  border-bottom: 1px solid #f0ece8;
  box-sizing: border-box;
}
.tabs .tab-item {
  position: relative;
  margin: 12px 22px 0 0;
  padding-bottom: 4px;
  color: #241f1b;
  font-size: 16px;
}
.tabs .tab-item.active {
  color: #ec7e2e;
}
.tabs .tab-item.active::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  border-radius: 2px;
  background: #ec7e2e;
  content: "";
}
.detail-content {
  flex: 1;
  min-height: 0;
  padding: 0 28px 34px;
  max-height: 600px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
}
.summary-row {
  display: flex;
  align-items: center;
  min-height: 54px;
  border-bottom: 1px solid #f0ece8;
  font-size: 14px;
}
.summary-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border-radius: 6px;
    background: linear-gradient(166deg, #0ABADE -4.53%, #2C75D2 89.74%);
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
.summary-value {
  margin-left: auto;
}
::v-deep .address-section h3 {
  margin: 14px 0 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}
::v-deep .address-card {
  margin-bottom: 8px;
  padding: 10px 16px 12px;
  border-radius: 4px;
  background: #f8f8f8;
}
::v-deep .address-label {
  color: #ffbd2d;
  font-size: 12px;
  line-height: 18px;
}
::v-deep .address-label.unloading {
  color: #ec7e2e;
}
::v-deep .factory-name {
  margin-top: 4px;
  color: #3d3833;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
}
::v-deep .detailed-address {
  margin-top: 2px;
  color: #85807b;
  font-size: 12px;
  line-height: 18px;
}
::v-deep .address-contact {
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  color: #3d3833;
  font-size: 12px;
  line-height: 18px;
}
::v-deep .contact-label {
  flex: none;
}
::v-deep .contact-value {
  flex: 1;
  text-align: right;
  word-break: break-all;
}
::v-deep .empty-address {
  color: #85807b;
  font-size: 14px;
}
.info-list {
  margin-top: 18px;
}
.info-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 42px;
  font-size: 14px;
  line-height: 22px;
}
.info-row span:first-child {
  flex: 0 0 86px;
}
.info-row span:last-child {
  flex: 1;
  text-align: right;
}
.empty-state {
  position: relative;
  z-index: 5;
  padding-top: 180px;
  color: #85807b;
  text-align: center;
}
</style>
